export function titleCapitalization(str = '', splitChar = ' ', joinWithSplitChar = false): string {
  // First split string by spaces iterate over each
  // Lastly join all words w/ space in between
  return str
    .split(splitChar)
    .map((each) => {
      let word

      // Handles Case there's an extra space in name
      if (each === '') {
        return
      }

      // If title includes an abbreviation
      if (each.includes('.')) {
        // recursively capitalize w/ the split char as "."
        return titleCapitalization(each, '.', true)
      }

      // make entire word lowercase
      word = each.toLowerCase()
      // make first letter capital and rest lowercase.
      return word[0].toUpperCase() + word.substring(1)
    })
    .join(joinWithSplitChar ? splitChar : ' ')
}

export function stripSpaces(value = '') {
  // Strips spaces from otp code
  return value.replace(' ', '')
}
